































































import { listFactory } from '@/main/pages/listFactory';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Partner } from '@/modules/kartoteka/partner';
import { OperationFlags } from '@/main/components/dms/common/operationFlagsConstants';

import { store } from './store/list';
import { NAME } from './constants';
import { listMutations } from './store/types';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		SkladMistoSelect: SkladMisto.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		VozidloSelect: Vozidlo.components.Select,
		PartnerSelect: Partner.components.Select,
	},
	data() {
		return {
			extraOperationsAloved: OperationFlags.DELETE,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				skladMistoOd: `${this.storeUri}/${listMutations.SKLAD_MISTO_OD_SELECT_MAPPER}`,
				skladMistoDo: `${this.storeUri}/${listMutations.SKLAD_MISTO_DO_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${listMutations.VOZIDLO_SELECT_MAPPER}`,
				zakaznik: `${this.storeUri}/${listMutations.ZAKAZNIK_SELECT_MAPPER}`,
				VstupZakaznik: `${this.storeUri}/${listMutations.VSTUP_ZAKAZNIK_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${listMutations.PRACOVNIK_SELECT_MAPPER}`,
				VstupPracovnik: `${this.storeUri}/${listMutations.VSTUP_PRACOVNIK_SELECT_MAPPER}`,
			};
		},
		skladmistoFilter(): object {
			return {
				VyrazenPrp: false,
			};
		},
	},
	methods: {
		async deleteClick({ data }: { data: { ID: number } }) {
			try {
				this.startLoading('table');
				await apiProvider.deleteEntity(data.ID);
				await this.tableData();
			} catch (error) {
				this.logError(error as Error);
			} finally {
				this.endLoading('table');
			}
		},
	},
});
